import axios from "axios";
import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

const FormData = () => {
  let navigate = useNavigate();
  let { IdData } = useParams();

  const { state, handleFunction } = useContext(GlobalContext);

  const {
    data,
    setData,
    fetchStatus,
    setFetchStatus,
    currentId,
    setCurrentId,
    checked,
    setChecked,
    input,
    setInput,
  } = state;

  const {
    handleEdit,
    handleDetail,
    handleDelete,
    handleText,
    handleInput,
    handleCheckbox,
    handleChecked,
    handleSubmit,
  } = handleFunction;

  useEffect(() => {
    if (IdData !== undefined) {
      axios
        .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`)
        .then((res) => {
          // console.log(res);
          let data = res.data;

          setInput({
            title: data.title,
            job_description: data.job_description,
            job_qualification: data.job_qualification,
            job_type: data.job_type,
            job_tenure: data.job_tenure,
            job_status: data.job_status,
            company_name: data.company_name,
            company_image_url: data.company_image_url,
            company_city: data.company_city,
            salary_min: data.salary_min,
            salary_max: data.salary_max,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [IdData]);

  console.log(input);
  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit}
        className="shadow-lg bg-white p-4 rounded-lg mt-5 max-h-min overflow-auto"
      >
        <h1 className="capitalize font-bold text-2xl text-black mb-2">
          Silahkan isi form untuk menambah lowongan Pekerjaan
        </h1>
        <div className="mb-6">
          <label
            htmlFor="title"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Nama Pekerjaan :
          </label>
          <input
            type="text"
            id="title"
            name="title"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.title}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="job_description"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Deskripsi:
          </label>
          <input
            type="text"
            id="job_description"
            name="job_description"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.job_description}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="job_qualification"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Kualifikasi:
          </label>
          <input
            type="text"
            id="job_qualification"
            name="job_qualification"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.job_qualification}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="job_type"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Tipe:
          </label>
          <input
            type="text"
            id="job_type"
            name="job_type"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.job_type}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="job_tenure"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Kontrak Kerja:
          </label>
          <input
            type="text"
            id="job_tenure"
            name="job_tenure"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.job_tenure}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="job_status"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Status :
          </label>
          <input
            type="checkbox"
            id="job_status"
            name="job_status"
            checked={checked}
            onChange={handleCheckbox}
            value={input.job_status}
          />
          <label
            htmlFor="dibuka"
            className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Masih dibuka
          </label>
        </div>
        <div className="mb-6">
          <label
            htmlFor="company_name"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Nama Perusahaan:
          </label>
          <input
            type="text"
            id="company_name"
            name="company_name"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.company_name}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="company_image_url"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Gambar Logo Perusahaan
          </label>
          <input
            type="text"
            id="company_image_url"
            name="company_image_url"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.company_image_url}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="company_city"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Domisili:
          </label>
          <input
            type="text"
            id="company_city"
            name="company_city"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.company_city}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="salary_min"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Gaji Minimal:
          </label>
          <input
            type="number"
            id="salary_min"
            name="salary_min"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.salary_min}
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="salary_max"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Gaji Maksimal :
          </label>
          <input
            type="number"
            id="salary_max"
            name="salary_max"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={handleInput}
            value={input.salary_max}
          />
        </div>
        <button
          type="submit"
          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Submit
        </button>
      </form>
    </React.Fragment>
  );
};

export default FormData;
